import styled from 'styled-components';

export const DialogContent = styled.div`
  display: flex;
  flex-direction: column;
  gap: 20px;
`;

export const InputWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 6px;
`;

export const TokenWrapper = styled(InputWrapper)`
  padding: 16px;
  align-items: center;
  text-align: center;

  label {
    font-weight: bold;
  }

  .e-input-group,
  .e-control-wrapper {
    width: 100%;
  }
`;

export const ButtonGroup = styled.div`
  display: flex;
  justify-content: space-between;
  gap: 12px;
`;

export const StyledButton = styled.button`
  .e-control.e-btn,
  .e-dropdown-btn,
  .e-tbar-button {
      background-color: var(--primaryColor) !important;
      border: 1px solid #D3D3D3 !important;
      border-radius: 12px !important;
      box-shadow: none !important;
      color: var(--primaryContrast) !important;
    }
  flex: 1;
  padding: 10px 16px;
  background-color: white !important;
  border: 1px solid #d3d3d3 !important;
  border-radius: 12px;
  box-shadow: none !important;
  color: black;
  font-weight: bold;
  cursor: pointer;
  transition: background 0.2s ease-in-out;

  &:hover {
    background-color: #f2f2f2;
  }
`;
